export const entityTypesWithOptional = [
  {
    text: 'Seleccione',
    id: 'ALL',
    default: true
  },
  {
    text: 'Tienda',
    id: 'TD',
    default: false
  },
  {
    text: 'Centro de distribución',
    id: 'CD',
    default: false
  }
];

export const entityTypesWithoutProvider = [
  {
    text: 'Tienda',
    id: 'TD',
    default: false
  },
  {
    text: 'Centro de distribución',
    id: 'CD',
    default: false
  }
];

export const entityTypes = [
  {
    text: 'Tienda',
    id: 'TD',
    default: true
  },
  {
    text: 'Centro de distribución',
    id: 'CD',
    default: false
  },
  {
    text: 'Proveedor',
    id: 'PRV',
    default: false
  }
];

export const allEntityTypes = entityTypes.concat([
  {
    text: 'Seller',
    id: 'SELLER',
    default: true
  },
]);

export const state = [
  { name: 'Activo', code: true },
  { name: 'Inactivo', code: false }
];

export const typeFiltro = [
  {
    name: 'Jerarquía',
    code: 'hierarchy',
  },
  {
    name: 'Atributo',
    code: 'attribute',
  }
];
export const filterZone = [
  {
    control: 'department',
    name: 'department',
    placeholder: 'Seleccionar departamento'
  },
  {
    control: 'province',
    name: 'province',
    placeholder: 'Seleccionar provincia'
  },
  {
    control: 'district',
    name: 'district',
    placeholder: 'Seleccionar distrito'
  }
];

export const descriptionAssignment = {
  locations: {
    nameList: 'Distritos y sub-zonas',
    listAssign: 'Distritos y sub-zonas asociadas',
    notifications: '* No existen entidades relacionadas a la provincia',
    showName: 'district',
    id: 'id'
  },
  entities: {
    nameList: 'Entidades',
    listAssign: 'Entidades asignadas',
    notifications: '* No se encontraron entidades',
    showName: 'entityName',
    id: 'entityCode',
    filter: 'text', // mat-selected nombre del option
    filterPlaceholder: 'Seleccionar tipo de entidad'
    // placefolter
  },
  zones: {
    nameList: 'Zonas',
    listAssign: 'Zonas asignadas',
    notifications: '* No se encontraron zonas',
    showName: 'name',
    id: 'zoneId',
    filter: 'department',
    filterPlaceholder: 'Seleccionar ciudad'
  },
  permiss: {
    nameList: 'Permisos',
    listAssign: 'Permisos asignados',
    showName: 'description',
    id: 'name',
  },
  attribute: {
    nameList: 'Atributos',
    listAssign: 'Atributos asignados',
    showName: 'category',
    id: 'attributeCodeBasic',
  }
};

export const causeSubZone = [
  {
    name: 'Restricción horaria',
    code: 'timeRestriction',
    isDistpatch: true
  },
  {
    name: 'Zona no permitida',
    code: 'zoneNotAllowed',
    isDistpatch: false
  }
];

export const typeZone = {
  sub_zone: {
    name: 'sub_zones',
    value: 'sub-zona'
  },
  zone: {
    name: 'zones',
    value: 'crear'
  },
  special_zone: {
    name: 'special_zones',
    value: 'zona-especial'
  }
};

export const nameButton = {
  createZone: {
    send: {
      name: 'Crear sub zona ',
      id: 'createSubZone'
    },
    update: {
      name: 'Actualizar sub zona ',
      id: 'update-s-z'
    },
    cancel: {
      name: 'Volver',
      id: 'createSubZone'
    }
  },
  createZoneSpecial: {
    send: {
      name: 'Crear zona especial',
      id: 'createSubZone'
    },
    update: {
      name: 'Actualizar zona especial',
      id: 'update-z-e'
    },
    cancel: {
      name: 'Volver',
      id: 'createSubZone'
    }
  },
  buttonDefault: {
    send: {
      name: 'Guardar',
      id: 'send'
    },
    update: {
      name: 'Actualizar',
      id: 'update'
    },
    cancel: {
      name: 'Volver',
      id: 'cancel'
    }
  }
};

export const measurementUnits = [
  {
    id: 'PER_UNIT_RULE',
    name: 'Unidades',
    rule: {
      productUnits: 12
    }
  },
  {
    id: 'PER_WEIGHT_RULE',
    name: 'Peso',
    rule: {
      startWeight: 1,
      startWeightUnit: 'kg',
      endWeight: 2,
      endWeightUnit: 'kg'
    }
  }
];

export const rangeShipping = {

};
